<div class="template" *ngIf="!mobile">
    <div class="row">
        <div class="col" style="margin-top:2%">
            <img src="../../assets/img/logo-hd.png"/>
        </div>
        <div class="col">
            <img src="../../assets/img/footer.png"/>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="h1">Cosmic Algorithm Ltd - eToro - Analysis</div>
        </div>
    </div>
    <div class="row">
        <div class="elfsight-app-1bd35861-fde3-4be5-9dfd-a51de5105af6"></div>
    </div>
    <div class="row">
        <div class="col">
           <img src="https://cosmicmedia-a0ce.restdb.io/media/Benchmarking Plot.jpg">
        </div>
    </div>
    <div class="row">
        <div class="col">
            <!-- <img src="https://cosmicmedia-a0ce.restdb.io/media/cbimage.png"> -->
            <app-main-graph></app-main-graph>
        </div>
    </div>
    <div class="row">
        <div class="col">
            You can view the current performance of Backseat Trader by visiting it's trading user account on eToro - <span style="color: #5ECE42"><b>cosmicetoro</b></span>
        </div>
    </div>
    <br/>
    <div class="row">
        <div class="col">
            <section class="section-image" id="etoroLoc">
                <div class="shell">
                    <div class="section__content">
                        <a href="https://www.etoro.com/?ref=18514998&compEligible=0&BannerID=4026&utm_medium=Direct&utm_source=11&utm_content=0&utm_serial=ShortURL_WS_CP&utm_campaign=ShortURL_WS_CP&utm_term="
                            class="btn btn--size-2" target="_blank">Join us on eToro</a>
                    </div>
                </div>
            </section>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <span style="font-size:medium"><b>Get started with US$500</b></span>
        </div>
    </div>
    <br/><br/>
    <div class="row">
        <div class="col">
            <img src="../../assets/img/Backseat Trader - Full Lockup - Green and Black.png"/>
        </div>
    </div>
    <br/>
</div>

<div style="text-align: center"*ngIf="mobile">
    <div class="row" style="margin-top: 5%">
        <div class="col">
            <img src="../../assets/img/logo-hd.png" style="margin-top: 14%"/>
        </div>
        <div class="col">
            <img src="../../assets/img/footer.png" style="max-width: 50%"/>
        </div>
    </div>
    <br/>
    <div class="row">
        <div class="col">
            <div class="h1">Cosmic Algorithm Ltd - eToro - Analysis</div>
        </div>
    </div>
    <br/>
    <div class="row">
        <div class="col">
           <img src="https://cosmicmedia-a0ce.restdb.io/media/Benchmarking Plot.jpg">
        </div>
    </div>
    <div class="row">
        <div class="col">
            <!-- <img src="https://cosmicmedia-a0ce.restdb.io/media/cbimage.png"> -->
            <app-main-graph></app-main-graph>
        </div>
    </div>
    <div class="row">
        <div class="col" style="font-size:medium">
            You can view the current performance of Backseat Trader by visiting it's trading user account on eToro - <span style="color: #5ECE42"><b>cosmicetoro</b></span>
        </div>
    </div>
    <br/>
    <div class="row">
        <div class="col">
            <section class="section-image" id="etoroLoc">
                <div class="shell">
                    <div class="section__content">
                        <a href="https://www.etoro.com/?ref=18514998&compEligible=0&BannerID=4026&utm_medium=Direct&utm_source=11&utm_content=0&utm_serial=ShortURL_WS_CP&utm_campaign=ShortURL_WS_CP&utm_term="
                            class="btn btn--size-2" target="_blank">Join us on eToro</a>
                    </div>
                </div>
            </section>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <span style="font-size:medium"><b>Get started with US$500</b></span>
        </div>
    </div>
    <br/><br/>
    <div class="row">
        <div class="col">
            <img src="../../assets/img/Backseat Trader - Full Lockup - Green and Black.png" style="max-width: 65%"/>
        </div>
    </div>
    <br/>
</div>

